


// 手机买药——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `medicine/zfb/index${i + 1}`,
  name: `medicineZfbIndex${i + 1}`,
  component: () => import(`@/views/health/medicine/zfb/index${i + 1}.vue`),
}));
// 手机买药——支付宝，分支1
const zfbBranch1Routes = Array.from({ length: 3 }, (_, i) => ({
  path: `medicine/zfb/branch1/index${i + 1}`,
  name: `medicineZfbBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/health/medicine/zfb/branch1/index${i + 1}.vue`),
}));
// 手机买药——支付宝，分支2
const zfbBranch2Routes = Array.from({ length: 4 }, (_, i) => ({
  path: `medicine/zfb/branch2/index${i + 1}`,
  name: `medicineZfbBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/health/medicine/zfb/branch2/index${i + 1}.vue`),
}));

export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [

    // 手机买药——支付宝，主流程
    ...zfbMainRoutes,

    // 手机买药——支付宝，分支1
    ...zfbBranch1Routes,

    // 手机买药——支付宝，分支2
    ...zfbBranch2Routes,
  ],
};
